import { render, staticRenderFns } from "./MapDataViewerPrintableLegendItem.vue?vue&type=template&id=b7be37f4&scoped=true&"
import script from "./MapDataViewerPrintableLegendItem.vue?vue&type=script&lang=js&"
export * from "./MapDataViewerPrintableLegendItem.vue?vue&type=script&lang=js&"
import style0 from "./MapDataViewerPrintableLegendItem.vue?vue&type=style&index=0&id=b7be37f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7be37f4",
  null
  
)

export default component.exports